import one from '../assets/svg/projects/one.svg'
import three from '../assets/svg/projects/three.svg'


export const projectsData = [
    {
        id: 1,
        projectName: 'Kickstarter Clone',
        projectDesc: 'Kickstarter exists to help bring creative project to life.This is a clone of Kickstarter which is an American public benefit corporation based in Brooklyn, New York, that maintains a global crowdfunding platform focused on creativity.',
        tags: ['React', 'Redux', 'CSS', 'Bootstrap'],
        code: 'https://github.com/HewaliGogoi/kickstarter',
        demo: 'https://apna-kickstarter.netlify.app/',
        image: ""
    },
    {
        id: 2,
        projectName: 'Netmeds Clone',
        projectDesc: 'Netmeds.com is a trusted Indian online pharmacy. Order prescription/OTC medicines online.',
        tags: ['HTML', 'CSS', "JavaScript"],
        code: 'https://github.com/Harsh-R-16/Netmeds-Clone',
        demo: 'netmeds-clone-harsh.netlify.app/',
        image: one
    },
    {
        id: 3,
        projectName: 'Golden Key',
        projectDesc: 'Etherium connecting wallet project',
        tags: ['React', 'CSS', 'Ether', "Figma", "Git"],
        code: 'https://github.com/amar969/GoldenKey',
        demo: 'https://goldenkeysociety.io',
        image: three
    },
    // {
    //     id: 4,
    //     projectName: 'Android Patient Tracker',
    //     projectDesc: 'This project involves the development of an Android application for viewing and managing patient data.',
    //     tags: ['Flutter', 'Firebase'],
    //     code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     image: four
    // },
    // {
    //     id: 5,
    //     projectName: 'E-Commerce App',
    //     projectDesc: 'A Simple E-commerce application',
    //     tags: ['React Native', 'Firebase'],
    //     code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     image: five
    // },
    // {
    //     id: 6,
    //     projectName: 'Uber Lite',
    //     projectDesc: 'Uber clone',
    //     tags: ['Flutter'],
    //     code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     image: six
    // },
    // {
    //     id: 7,
    //     projectName: 'Stock Market App',
    //     projectDesc: 'A simple stock market API app',
    //     tags: ['React', 'Redux', 'Bootstrap'],
    //     code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     image: seven
    // },
    // {
    //     id: 8,
    //     projectName: 'Car Pooling System',
    //     projectDesc: 'The carpooling system merges multiple people in a car which leads to meet new people, reduces pollution',
    //     tags: ['Flutter', 'React'],
    //     code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     image: eight
    // },
]


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/